import {BasePolicyStatus} from '../../../../../../coverpath-common/angular/components/account-center/policy-status/base-policy-status';
import {Product} from '../../../../../../common/js/static/Product';
import {AmorphicService} from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { MMDirectPolicy } from '../../../../../../coverpath-common/classes/mmdirect_subclasses/MMDirectPolicy';
import { AccountCenterService } from "../../../../../../coverpath-common/angular/services/account-center/account-center.service";


export class MMDirectPolicyStatus extends BasePolicyStatus {
    policy: MMDirectPolicy;

    constructor(amorphicService: AmorphicService, policy: MMDirectPolicy, accountCenterService: AccountCenterService) {
        super(amorphicService, policy, accountCenterService);
        this.policy = policy;
        this.setAllProperties();
    }

    setAllProperties() {
        this.contactNumber = Product.channels.MMDirect.phone;
        this.hasAgent = false;
        super.setAllProperties();
    }
}